module.exports = __webpack_public_path__ + "fonts/4c6503c9-859b-4d3b-a1d5-2d42e1222415.a41b0c80.ttf";